import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import { LanguageProvider } from '@/context/LanguageContext';
import Nav, { DonateModal, useDonate } from '@/components/Nav';
import Footer from '@/components/Footer';
import EditorialMarquee from '@/components/EditorialMarquee';
import Home from '@/pages/Home';
import Gallery from '@/pages/Gallery';
import About from '@/pages/About';
import CV from '@/pages/CV';
import Shop from '@/pages/Shop';
import Contact from '@/pages/Contact';

const SmoothScroll = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [location.pathname]);

    return children;
};

const Shell = () => {
    const donate = useDonate();
    return (
        <SmoothScroll>
            <div className="noise-overlay" aria-hidden />
            <Nav onDonate={() => donate.setOpen(true)} />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/about" element={<About />} />
                <Route path="/cv" element={<CV />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Home />} />
            </Routes>
            <EditorialMarquee />
            <Footer />
            <DonateModal open={donate.open} onClose={() => donate.setOpen(false)} />
        </SmoothScroll>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <LanguageProvider>
                    <Shell />
                    <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: '#121212', border: '1px solid rgba(255,255,255,0.1)', color: '#F4F1EB' } }} />
                </LanguageProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
